import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

import { EXPORT_HUBSPOT_BTN, EXPORT_INTEGRATION_TOOLTIP } from "../../translations/ExportItem";
import type { WebsitesIntegrationExportItemProps } from "../types";
import { ExportIntegrations } from "app/pages/sales-intelligence/pages/management/types/types";

const WebsitesHubSpotExportItem = ({
    isDisabled,
    onClick,
    tooltipDisabledContent,
    tooltipContent,
    text,
    isUseLockedIcon = true,
}: WebsitesIntegrationExportItemProps) => {
    const disabledContent =
        tooltipDisabledContent ?? translate(EXPORT_INTEGRATION_TOOLTIP, { integrationName: "HubSpot" });

    const optionText = text ?? translate(EXPORT_HUBSPOT_BTN);

    return (
        <ExportVariantsDropdownItem
            iconName={ExportIntegrations.hubspot}
            isDisabled={isDisabled}
            variant={ExportIntegrations.hubspot}
            text={optionText}
            tooltipDisabledContent={disabledContent}
            onClick={onClick}
            isUseLockedIcon={isUseLockedIcon}
            tooltipContent={tooltipContent}
        />
    );
};

export default WebsitesHubSpotExportItem;
